import { joinURLPath } from '@sigma-frontend-libs/commons'

import { globalErrorHandler, request, services } from '@/utils'

import render from './render'

export default {
  name: 'UpdateStatus',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      loading: false
    }
  },

  methods: {
    async updateStatus() {
      try {
        this.loading = true
        await request.update(joinURLPath(services.yclients, this.value.id), {
          body: {
            ...this.value,
            isActive: true,
            error: null
          }
        })
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
      }
    }
  },

  render
}
